/** @typedef {Record<string, unknown>} SarvamRecord */

export const SARVAM_TABS = [
  ["overview", "Overview"],
  ["plans", "Automation plans"],
  ["runs", "Runs"],
  ["campaigns", "Campaigns"],
  ["recovery", "Result recovery"],
  ["legacy", "Legacy batch"],
];

export function listFrom(data, keys = []) {
  if (Array.isArray(data)) return data;
  for (const key of keys) if (Array.isArray(data?.[key])) return data[key];
  return [];
}

export function valueOf(item, keys, fallback = "—") {
  for (const key of keys) {
    if (item?.[key] !== undefined && item?.[key] !== null && item[key] !== "") return item[key];
  }
  return fallback;
}

export function formatDate(value) {
  if (!value) return "—";
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? String(value) : `${date.toLocaleString()}${/[zZ]|[+-]\d\d:?\d\d$/.test(String(value)) ? " UTC" : ""}`;
}

export function today() {
  return new Date().toISOString().slice(0, 10);
}
